import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import type { TFunction } from 'react-i18next'
import { Input } from '../../../components'
import type { Variant } from '../../../types'
import type { ExtendedVariant } from './Variants'

interface TableDisplayParams {
    onSelectVariant: (id: number, isSelected: boolean) => void;
    t: TFunction;
}

const tableDisplay = ({ onSelectVariant, t }: TableDisplayParams) => {
    const elements = [
        {
            onlyOnMobile: true,
            field: null,
            label: '',
            props: { align: 'center' },
            transform: ({ id, selected = false }: ExtendedVariant) => (
                <Input
                    onChange={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        onSelectVariant(id, !selected)
                    }}
                    type="check"
                    value={selected}
                />
            ),
            width: '50px',
        },
        {
            onlyOnMobile: true,
            field: 'start_date',
            label: t('variant-start-date'),
            props: { paddingLeft: '15px', textAlign: 'left' },
            transform: (dateStart: string) => (
                <>{moment(dateStart).format('DD/MM/YYYY')}</>
            ),
            width: '100px',
        },
        {
            field: null,
            label: '',
            props: null,
            transform: () => (
                <FontAwesomeIcon icon="chevron-right" />
            ),
            width: '20px',
        },
        {
            field: null,
            label: '',
            props: { align: 'center' },
            transform: ({ id, selected = false }: ExtendedVariant) => (
                <Input
                    onChange={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        onSelectVariant(id, !selected)
                    }}
                    type="check"
                    value={selected}
                />
            ),
            width: '50px',
        },
        {
            field: 'start_date',
            label: t('variant-start-date'),
            props: { paddingLeft: '15px' },
            transform: (dateStart: string) => (
                <>{moment(dateStart).format('DD/MM/YYYY')}</>
            ),
            width: '120px',
        },
        {
            field: 'end_date',
            label: t('variant-end-date'),
            props: null,
            transform: (dateEnd: string) => (
                <>{moment(dateEnd).format('DD/MM/YYYY')}</>
            ),
            width: '120px',
        },
        {
            field: 'skus',
            label: t('variant-skus'),
            props: { align: 'center' },
            transform: (skus: Variant['skus']) => (
                <>{skus.length}</>
            ),
            width: '80px',
        },
        {
            field: 'exceptions',
            label: t('variant-exception-stores'),
            props: { align: 'center' },
            transform: (exceptions: Variant['exceptions']) => (
                <>{exceptions.stores.length === 0 ? t('variant-all-storecodes') : exceptions.stores.length}</>
            ),
            width: '110px',
        },
    ]

    return elements
}

export default tableDisplay
